var React = require('react');

function Tag (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t2.4,1.2 13.6,1.2 13.6,14.8 7.9,11.9 2.4,14.7 \t"})));
}

Tag.displayName = "Tag";

Tag.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Tag;

Tag.default = Tag;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/tag.svg
// module id = ../icon/src/icons/tag.svg
// module chunks = 0